export const FETCH_PRODUCT_STOCK_DATA_REQUEST = 'FETCH_PRODUCT_STOCK_DATA_REQUEST';
export const FETCH_PRODUCT_STOCK_DATA_SUCCESS = 'FETCH_PRODUCT_STOCK_DATA_SUCCESS';
export const FETCH_PRODUCT_STOCK_DATA_FAILURE = 'FETCH_PRODUCT_STOCK_DATA_FAILURE';

export const NAVIGATE_PRODUCT_DISPATCH_HEADER = 'NAVIGATE_PRODUCT_DISPATCH_HEADER';

export const CREATE_USER_FORM_PRODUCT_DISPATCH = 'CREATE_USER_FORM_PRODUCT_DISPATCH';

export const SET_UNIT_NAME_PRODUCT_DISPATCH = 'SET_UNIT_NAME_PRODUCT_DISPATCH';

export const CREATE_PRODUCT_DISPATCH_REQUEST = 'CREATE_PRODUCT_DISPATCH_REQUEST';
export const CREATE_PRODUCT_DISPATCH_SUCCESS = 'CREATE_PRODUCT_DISPATCH_SUCCESS';
export const CREATE_PRODUCT_DISPATCH_FAILURE = 'CREATE_PRODUCT_DISPATCH_FAILURE';

export const FETCH_PRODUCT_DISPATCH_SALES_ORDER_REQUEST = 'FETCH_PRODUCT_DISPATCH_SALES_ORDER_REQUEST';
export const FETCH_PRODUCT_DISPATCH_SALES_ORDER_SUCCESS = 'FETCH_PRODUCT_DISPATCH_SALES_ORDER_SUCCESS';
export const FETCH_PRODUCT_DISPATCH_SALES_ORDER_FAILURE = 'FETCH_PRODUCT_DISPATCH_SALES_ORDER_FAILURE';

export const CREATE_USERFORM_PRODUCT_DISPATCH_TABLE_LIST_DATA = 'CREATE_USERFORM_PRODUCT_DISPATCH_TABLE_LIST_DATA';

export const NAVIGATE_PRODUCT_DISPATCH_DETAIL = 'NAVIGATE_PRODUCT_DISPATCH_DETAIL';

export const CREATE_PRODUCT_DISPATCH_DETAIL_REQUEST = 'CREATE_PRODUCT_DISPATCH_DETAIL_REQUEST';
export const CREATE_PRODUCT_DISPATCH_DETAIL_SUCCESS = 'CREATE_PRODUCT_DISPATCH_DETAIL_SUCCESS';
export const CREATE_PRODUCT_DISPATCH_DETAIL_FAILURE = 'CREATE_PRODUCT_DISPATCH_DETAIL_FAILURE';

export const DELETE_PRODUCT_DISPATCH_HEADER_REQUEST = 'DELETE_PRODUCT_DISPATCH_HEADER_REQUEST';
export const DELETE_PRODUCT_DISPATCH_HEADER_SUCCESS = 'DELETE_PRODUCT_DISPATCH_HEADER_SUCCESS';
export const DELETE_PRODUCT_DISPATCH_HEADER_FAILURE = 'DELETE_PRODUCT_DISPATCH_HEADER_FAILURE';

export const FETCH_PRODUCT_DISPATCH_DETAIL_DATA_REQUEST = 'FETCH_PRODUCT_DISPATCH_DETAIL_DATA_REQUEST';
export const FETCH_PRODUCT_DISPATCH_DETAIL_DATA_SUCCESS = 'FETCH_PRODUCT_DISPATCH_DETAIL_DATA_SUCCESS';
export const FETCH_PRODUCT_DISPATCH_DETAIL_DATA_FAILURE = 'FETCH_PRODUCT_DISPATCH_DETAIL_DATA_FAILURE';

export const PRODUCT_DISAPTCH_USERFORM_RESET = 'PRODUCT_DISAPTCH_USERFORM_RESET';

export const DELETE_PRODUCT_DISPATCH_DETAIL_REQUEST = 'DELETE_PRODUCT_DISPATCH_DETAIL_REQUEST';
export const DELETE_PRODUCT_DISPATCH_DETAIL_SUCCESS = 'DELETE_PRODUCT_DISPATCH_DETAIL_SUCCESS';
export const DELETE_PRODUCT_DISPATCH_DETAIL_FAILURE = 'DELETE_PRODUCT_DISPATCH_DETAIL_FAILURE';

export const FETCH_WAREHOUSE_SALES_ORDER_LIST_REQUEST = 'FETCH_WAREHOUSE_SALES_ORDER_LIST_REQUEST';
export const FETCH_WAREHOUSE_SALES_ORDER_LIST_SUCCESS = 'FETCH_WAREHOUSE_SALES_ORDER_LIST_SUCCESS';
export const FETCH_WAREHOUSE_SALES_ORDER_LIST_FAILURE = 'FETCH_WAREHOUSE_SALES_ORDER_LIST_FAILURE';

export const FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_REQUEST = 'FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_REQUEST';
export const FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_SUCCESS = 'FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_SUCCESS';
export const FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_FAILURE = 'FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_FAILURE';

export const FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_REQUEST = 'FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_REQUEST';
export const FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_SUCCESS = 'FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_SUCCESS';
export const FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_FAILURE = 'FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_FAILURE';

export const FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_REQUEST = 'FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_REQUEST';
export const FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_SUCCESS = 'FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_SUCCESS';
export const FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_FAILURE = 'FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_FAILURE';